import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/_layout/inventory/asset-incidents"
)({
  component: RouteComponent,
});

function RouteComponent() {
  // AssetIncidentLogViewSet is a ReadOnlyModelViewSet -- no write route
  // exists at all, so read_permission ("inventory.stock.view") is the only
  // gate that ever applies here, with no degrade-to-own-rows fallback.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <AssetIncidentsPage />
    </ProtectedRoute>
  );
}

import { ProtectedRoute } from "@/components/protected-route";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import PageHeader from "@/components/reusable-components/header/page-header";
import { PaginationComponent } from "@/components/crud/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "@/lib/constants";
import { usePaginationState } from "@/hooks/ui/usePaginationState";
import { useFetchAssetIncidents } from "@/hooks/api/inventory/useAssetIncidents";
import { AssetIncidentTable } from "@/components/inventory/tables/AssetIncidentTable";

function AssetIncidentsPage() {
  const { page, setPage, pageSize, handlePageSizeChange } =
    usePaginationState();

  const incidentsQuery = useFetchAssetIncidents({ page_size: pageSize, page });
  const incidents = incidentsQuery.data?.results ?? [];
  const count = incidentsQuery.data?.count ?? 0;
  const isLoading = incidentsQuery.isPending;
  const isFetching = incidentsQuery.isFetching;

  return (
    <SidebarInset>
      <DashboardHeader />

      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Asset Incidents"
          description="View damage, loss, and incident records logged against serialized assets."
          isLoading={isLoading}
        />

        <AssetIncidentTable incidents={incidents} isLoading={isLoading} />

        <PaginationComponent
          count={count}
          page={page}
          onPageChange={setPage}
          isLoading={isFetching}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
        />
      </div>
    </SidebarInset>
  );
}
